import { NumberInput, MultilineInput } from "@tblabs/truffle";
import { DescriptionEditor } from "../../Components/Description/DescriptionEditor";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { PrimaryButton } from "../../Components/Utils/PrimaryButton";
import { SecondaryButton } from "../../Components/Utils/SecondaryButton";
import { SinglePictureEdit } from "./SinglePictureEdit";
import { FaqListEditor } from "../../Components/Description/Faq/FaqsEditor";
import { Notification } from "../../Components/Notification";
import { DiscountsTable } from "./DiscountsTable";
import { Page } from "../Product/Page";
import { Panel } from "../Product/Panel";
import { FormRow, FormPrinter } from "../Product/InputsPrinter";
import { ColumnBox } from "../Product/ColumnBox";
import { DangerButton, DefaultButton } from "../../Components/Utils/DangerButton";


export class PageEditPage extends Page
{
    constructor(private _shop: ShopContentProvider)
    {
        super("specTeam.pl - Edycja strony głównej", "admin-page");

        this.Content(async (body) =>
        {
            await this._shop.Load();

            const web = this._shop.Shop;

            body.Append(
                new Panel("Ustawienia cennika", [
                    new FormPrinter([
                        new FormRow("Ogólny mnożnik ceny", new NumberInput(web.BasketOptions.GeneralPriceFactor).Step(0.01).Min(0)),
                        new FormRow("Koszt dostawy przy cenie powyżej 300zł", new NumberInput(web.BasketOptions.DeliveryCostForPriceAbove300).Step(1).Min(0)),
                        new FormRow("Koszt dostawy przy cenie poniżej 300zł", new NumberInput(web.BasketOptions.DeliveryCostForPriceBelow300).Step(1).Min(0)),
                        new FormRow("Kody rabatowe", new DiscountsTable(web.BasketOptions.Discounts)),
                        // ["Usługi dodatkowe", new DiscountsTable(web.BasketOptions.Extras)],
                    ]),
                ]),
                new Panel("Elementy na stronie", [
                    new FormPrinter([
                        new FormRow("Logo", new SinglePictureEdit(web.Logo)),
                    ]),
                ]),
                new Panel(`Sekcja "O nas"`, [
                    new FormPrinter([
                        new FormRow("Tekst", new MultilineInput(web.AboutUsText).Rows(12)),
                        new FormRow("Q&A", new FaqListEditor(web.AboutUsFaq)),
                    ]),
                ]),
                new Panel(`Podstrona "Wypożyczalnia"`, [
                    new DescriptionEditor(web.RentalPageContent, web.RentalPageContentTabs),
                ]),
                new Panel(`Podstrona "Kontakt"`, [
                    new DescriptionEditor(web.Contact, web.ContactTabs),
                ]),
                // new FoldableSection("Kontakt", [
                //     new DescriptionEditor(web.Contact),
                // ]),
                // new FoldableSection("Blog", [
                //     new CollectionPrinter(content.Blog, x => new BlogEntry(x, content.Blog)),
                //     new AddFieldBox(
                //         new Link("➕ Artykuł").OnClick(() => content.Blog.Add(new BlogArticle({})))
                //     ),
                // ]),
                new ColumnBox(
                    new PrimaryButton("Zapisz i wróć na stronę główną").OnClick(async () =>
                    {
                        await this.SaveChanges();
                        history.back();
                    }),
                    new PrimaryButton("Tylko zapisz").OnClick(async () =>
                    {
                        await this.SaveChanges();
                    }),
                    new DefaultButton("Wykonaj backup").OnClick(async () =>
                    {
                        const result = await this._shop.Backup();

                        new Notification(result.IsSuccess ? "✅ Backup wykonany!" : "❌ Problem z wykonaniem backupu",
                            result.ErrorMessage || "Saved at: " + result.BackupDirectory, result.IsSuccess ? 3500 : 0);
                    }),
                ),
            );
        });
    }

    private async SaveChanges(): Promise<void>
    {
        const result = await this._shop.SaveChanges();

        new Notification(result.IsSuccess ? "✅ Zmiany zapisane!" : "❌ Problem z zapisaniem zmian",
            result.ErrorMessage || (result.ContentSize.toFixed(2) + "kb"));
    }
}
